import EventCalendar from "@shared/modules/events/components/calendar/EventCalendar/EventCalendar.web";
import Button from "@ui-kit/form/Button/Button.web";
import Box from "@ui-kit/layout/Box/Box.web";
import { useTranslation } from "@shared/utils/internationalization";
import { WizardStep } from "@shared/components/application/navigation/Wizard/WizardStep.web";
import { useWizardContext } from "@shared/contexts/WizardContext/WizardContext";
import { useEffect } from "react";
import { AnalyticsService } from "@shared/services/analytics";
import { enums } from "@shared/constants";
import { EVENT_WIZARD_SCREENS_MAP } from "../types";
import { EventCalendarScreenProps } from "./EventCalendarScreen.props";

export const EVENT_CALENDAR_SCREEN_ID = EVENT_WIZARD_SCREENS_MAP.CALENDAR.id;

function EventCalendarScreen({
  onDismiss,
  footerProps,
  hideFooter,
  event,
  ...rest
}: EventCalendarScreenProps) {
  const { t } = useTranslation("common");
  const { currentStep, currentIndex } = useWizardContext();
  const disableBackButton =
    currentStep?.id === EVENT_CALENDAR_SCREEN_ID && currentIndex === 0;

  useEffect(() => {
    AnalyticsService.eventViewed(event, {
      label: enums.INTERACTION_LABEL_MAP.EVENT_CALENDAR.id,
    });
  }, [event]);

  return (
    <WizardStep stepId={EVENT_CALENDAR_SCREEN_ID} stepName={t("Date and time")}>
      <Box
        display="flex"
        flexDirection="column"
        flex="1 1 auto"
        minHeight={0}
        backgroundColor="bg"
      >
        <EventCalendar {...rest} />
      </Box>
      {!hideFooter && (
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          borderTop="1px solid var(--chakra-colors-gray-400)"
          p={{
            base: "16px 24px",
            sm: "16px 20px",
          }}
          id="calendar-modal-footer"
          backgroundColor="bg"
          borderBottomRadius="md"
        >
          {onDismiss && (
            <Button.Ghost
              data-testid="event-calendar-back"
              onClick={onDismiss}
              disabled={disableBackButton}
            >
              {t("Back")}
            </Button.Ghost>
          )}
          {footerProps?.continueButton}
        </Box>
      )}
    </WizardStep>
  );
}

export default EventCalendarScreen;
